import { useQuery } from '@tanstack/react-query';

import { getMarketRoi } from '@arrived/api_v2';
import { MarketId, MarketROI } from '@arrived/models';

import { MAX_STALE_TIME, UseQueryOptions, UseQueryResult } from '../queries.utils';
import { marketsRoiKeyFn } from './markets.keys';

export function useMarketROIQuery(
  marketId?: MarketId,
  options?: UseQueryOptions<MarketROI>
): UseQueryResult<MarketROI> {
  return useQuery(marketsRoiKeyFn(marketId!), async () => getMarketRoi(marketId!), {
    ...options,
    staleTime: options?.staleTime ?? MAX_STALE_TIME,
    enabled: Boolean(marketId) && (options?.enabled ?? true),
  });
}
